const state = {
  all: [],
}
const getters = {
  feeds: state => {
    return state.all
  },
}
const actions = {
  async getAll() {
    return state.all
  },

  async save({ commit }, params) {
    commit('setFeeds', params)
    return state.all.length
  },
}
const mutations = {
  setFeeds(state, feeds) {
    state.all.splice(0, 0, {
      dateComment: feeds.dateComment,
      userComment: feeds.userComment,
      invoiceId: Array.isArray(feeds.invoiceId)
        ? feeds.invoiceId.toString()
        : feeds.invoiceId,
      action: feeds.action,
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
